// Use the return result as removal
// Example: this.eventListener = addEventListenerToObject(...,...,...);
// When removing use this.eventListener.remove();
export const addEventListenerToObject: (object: HTMLElement | Window, event: string, eventHandler: (event: Event) => void) => { remove: () => void } = (object, event, eventHandler) => {
  object.addEventListener(event, eventHandler);
  return {
    remove: () => object.removeEventListener(event, eventHandler)
  };
};
